module.exports = "/assets/9bd5c0eaf60f6fb758c396d74bc4c0a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/X7.png
// module id = 3104
// module chunks = 0